/* eslint-disable import/no-extraneous-dependencies */
import { Grid } from '@mui/material';
import { BasicButton } from '@tassat/button';
import { SimpleErrorMessage, TextField } from '@tassat/formik-input';
import { ActionTypes } from '@tassat/ui-definitions';
import { Formik, FormikProps } from 'formik';
import * as React from 'react';

import { validateAddAcgNumberForm } from './submission';
import { IFormProps, IFormValues, IFormikProps } from './types';

const FormContents = (props: IFormProps) => {
    const {
        classes,
        values,
        errors,
        submitForm,
        isValid,
        isSubmitting,
        dirty,
        formProps,
        submitError
    } = props;

    const { actionType } = formProps;

    return (
        <form className={classes.flexColumn}>
            <Grid
                container
                direction='row'
                item
                justifyContent='space-around'
                sm={12}
                spacing={2}
            >
                <Grid
                    item
                    md={3}
                    sm={3}
                >
                    <TextField
                        disabled={actionType === ActionTypes.edit}
                        errors={errors}
                        label='ACG Number'
                        maxLength={5}
                        name='ACGNumber'
                        placeholder='12345'
                        values={values}
                    />
                </Grid>
                <Grid
                    item
                    md={9}
                    sm={9}
                >
                    <TextField
                        errors={errors}
                        label='ACG Name'
                        maxLength={48}
                        name='ACGName'
                        placeholder='48 Character Name'
                        values={values}
                    />
                </Grid>
            </Grid>
            <BasicButton
                className={classes.submitButton}
                disabled={!dirty ||
                    isSubmitting ||
                    !isValid}
                onClick={submitForm}
                text='Submit'
                type='submit'
            />
            <SimpleErrorMessage
                className={classes.submitError}
                error={submitError}
            />
        </form>
    );
};

export default function AddACGNumberForm(props: IFormikProps) {
    const {
        classes,
        onClose,
        formProps
    } = props;

    const {
        actionType,
        submitAddAcgNumberForm,
        activeAcgs,
        editACGNum
    } = formProps;

    const [ submitError, setSubmitError ] = React.useState<string>('');

    let initialValues = {} as IFormValues;

    if (actionType === ActionTypes.add) {
        initialValues = {
            ACGNumber: '',
            ACGName: ''
        };
    } else if (actionType === ActionTypes.edit) {
        const {
            ACGNumber,
            ACGName,
            ACGId
        } = editACGNum;

        if (!ACGNumber) return <div />;

        initialValues = {
            ACGNumber,
            ACGId,
            ACGName
        };
    }

    const addAcgNumberOriginalValidations = (values: IFormValues) => validateAddAcgNumberForm(values, {
        actionType,
        initialValues,
        activeAcgs
    });

    return (
        <Grid
            container
            direction='column'
            spacing={0}
            wrap='nowrap'
        >
            <Grid
                item
                sm={12}
            >
                <Formik
                    initialValues={initialValues}
                    onSubmit={async (values: IFormValues) => {
                        try {
                            await submitAddAcgNumberForm(values, {
                                onClose,
                                setSubmitError,
                                actionType
                            });
                        } catch (error) {
                            setSubmitError('Something went wrong');
                        }
                    }}
                    validate={(values: IFormValues) => (
                        addAcgNumberOriginalValidations(values)
                    )}
                    validateOnChange
                    validateOnMount
                >
                    {(formContentsProps: FormikProps<IFormValues>) => (
                        <FormContents
                            {...formContentsProps}
                            classes={classes}
                            formProps={formProps}
                            submitError={submitError}
                        />
                    )}
                </Formik>
            </Grid>
        </Grid>
    );
}